<template>
  <div class="chatroom-home">
    <div v-if="changeStat"></div>
    <!-- Floating button chat -->
    <a @click="togleChat()" class="float" v-if="isMobile">
      <i class="fa fa-plus my-float">
        <svgicon icon="chat"/>
      </i>
    </a>

    <div id="live-chat" v-if="(isMobile && !isChatOpen ) || !isMobile ">
      <!-- Header of chat -->
      <header class="clearfix">
        <!-- Chat bar when is open -->
        <div class="chat-bar-open" v-if="!this.isChatOpen">
          <div>
            <div @click="modalLeavGroupe = true" v-if="!isPublic &&  !isUserJoind && !this.isUserProPrio()">
              <div class="tooltip">
                <svgicon icon="leave-groupe"/>
                <span class="tooltiptext">Quitter le groupe</span>
              </div>
            </div>
          </div>
          <UsersAvatars :users="chatHome.users" :chatOpen="false"/>
          <div>
            <span @click="togleChat()"><svgicon icon="arrow-reduir" style="width: 20px;"/></span>
          </div>
        </div>

        <!-- Chat bar when is close -->

        <div class="chat-bar-close" v-else>
          <img src="/static/images/icon-chat.png"/>
          <div class="chat-coloc">Chat de la co-location</div>
          <UsersAvatars :users="chatHome.users" :chatOpen="true"/>
          <div/>
          <div @click="togleChat()">
            <img
              src="/static/images/round_navigate_next_black_18dp.png"
              alt=""
              class="arrow-top"
            />
          </div>
        </div>
      </header>

      <!-- loading data  -->

      <div class="chat-cnt">

        <div class="loader-wrapper" v-if="currentChat.loading">
          <div class="loader big"></div>
        </div>

        <div class="chat" v-else>
          <div class="chat-history scroller-bar" id="chatScroll">
            <div class="chatroom">
              <div class="msg-container">
                <div class="chat-left">
                  <div class="container-chatroom clear-after">
                    <!-- messages chat -->
                    <div class="message-chat">
                      <section class="container-msg" v-if="currentChat">
                        <!-- Header -->
                        <div class="mobil-header" v-if="isMobile">
                          <img
                            src="/static/images/arrow-l.png"
                            alt=""
                            class=""
                            v-if="!toggleMembersContent"
                            @click="togleChat()"
                          />

                          <div
                            v-for="(item, index) of imgTab"
                            v-bind:key="'tab-' + index"
                          >
                            <div
                              v-bind:class="
                                index == selectTab ? 'selected-tab' : ''
                              "
                            >
                              <img
                                :src="item"
                                alt=""
                                v-bind:class="
                                  index == selectTab ? 'svg-icons' : ''
                                "
                                @click="selectTab = index"
                              />
                            </div>
                          </div>

                          <div></div>
                        </div>
                        <!-- Messages -->
                        <div
                          v-if="this.selectTab === 0"
                          :key="currentChat.id"
                          :id="'msg-user-id-' + currentChat.id"
                          class="sscontainer-msg active scroller"
                          ref="scroll_container"
                        >
                          <div
                            class=""
                            :class="{
                              'sssscontainer-msg--disliked':
                                currentChat.dislike,
                            }"
                          >
                            <div
                              v-if="
                                !has_subscription &&
                                currentChat.name !== 'Service Client'
                              "
                            >
                              <h2>Accès non autorisé</h2>
                              <p>La messagerie est réservée aux abonnés.</p>
                              <router-link
                                class="bt-abo red-btn"
                                :to="{ name: 'DashboardSubscription' }"
                              >S'abonner
                              </router-link
                              >
                            </div>
                            <div v-else-if="currentChat.dislike">
                              <h2>Utilisateur bloqué</h2>
                              <ui-button
                                @click="toggleBlockUser(currentChat)"
                                id="block-user"
                              >Débloquer
                              </ui-button
                              >
                            </div>
                            <template v-else>
                              <template
                                v-for="(msg, index) of (getCurrentMesageFilter())"
                              >
                                <div
                                  v-if="msg.is_information || checkInformationMsg(msg.body)"
                                  v-bind:key="'info-' + index"
                                  class="information-msg"
                                >
                                  {{ msg.body }}
                                </div>

                                <div v-else v-bind:key="'msg-' + index">
                                  <div
                                    v-bind:class="
                                     !isPublic && msg.user_id === user.id
                                        ? 'row-head-sending'
                                        : 'row-head-comming'
                                    "
                                  >
                                    <div
                                      v-bind:class="
                                      !isPublic &&  msg.user_id === user.id
                                          ? 'user-heure-sending'
                                          : 'user-heure-comming'
                                      "
                                    >
                                      <div class="user-name">
                                        <router-link :to="{ name: 'UserProfile', params: { user_id: msg.user_id }}"
                                                     target="_blank" v-if="msg.user_deleted_at == null">
                                          {{ getUserNameFromMessage(msg) }},
                                        </router-link>
                                        <div v-else> P.N,</div>
                                      </div>
                                      {{
                                        msg.saving
                                          ? ''
                                          : formatDate(msg.created_at)
                                      }}
                                    </div>
                                  </div>

                                  <div
                                    class="un-message row"
                                    :class="{ 'message--saving': msg.saving }"
                                    :id="
                                      index === currentChat.messages.length - 1
                                        ? 'message--last'
                                        : ''
                                    "
                                    :key="'msg' + msg.id"
                                  >
                                    <div
                                      :class="
                                        'pic-' + ((isPublic && !user ) ||  msg.user_id !== user.id)
                                      "
                                      class="block-photo-msg-g"
                                    >
                                      <div
                                        v-if="(isPublic && !user ) || (user &&  msg.user_id !== user.id)"
                                        class="container-photo-msg"
                                      >
                                        <div>
                                          <chat-picture
                                            :users="[
                                            msg.avatar_id
                                              ? {
                                                  avatar_id: msg.avatar_id,
                                                  avatar_color: msg.avatar_color
                                                }
                                              :
                                              getAvatar(msg.user_id),
                                          ]"
                                            :h="'46px'"
                                            :w="'46px'"
                                          />
                                          <div class="connected-status">
                                            <div
                                              class="status"
                                              v-bind:class="
                                                isUserConnected(msg.user_id)
                                                  ? 'connected'
                                                  : 'disconnected'
                                              "
                                            ></div>
                                          </div>
                                        </div>

                                        <span class="fleche-msg-g"></span>
                                      </div>
                                    </div>
                                    <div class="block-central">
                                      <div class="row msg-cnt">
                                        <div
                                          v-if="user && msg.user_id === user.id"
                                          class=" block-heure"
                                        ></div>
                                        <div
                                          :class="
                                            'my-msg-' +
                                            (user && msg.user_id !== user.id)
                                          "
                                          class="block-texte text-msg"
                                        >
                                          <p class="overflow-text"
                                             v-html="textToHTML(msg.body, true)"
                                          ></p>
                                        </div>
                                        <div
                                          v-if="(isPublic && !user )|| ( msg.user_id !== user.id)"
                                          class=" block-heure"
                                        ></div>
                                      </div>
                                    </div>
                                    <div
                                      :class="
                                        'pic-' + (!user || (user && msg.user_id !== user.id))
                                      "
                                      class="block-photo-msg-d"
                                    >
                                      <div v-if="user && msg.user_id === user.id">
                                        <chat-picture
                                          :users="[
                                            user.avatar && user.avatar.approved
                                              ? {
                                                  avatar_id: user.avatar.id,
                                                  avatar_color:
                                                    user.avatar.color,
                                                }
                                              : {},
                                          ]"
                                          :h="'46px'"
                                          :w="'46px'"
                                          v-if="msg.user_id === user.id"
                                        />
                                        <div class="connected-status">
                                          <div
                                            class="status sender-user"
                                            v-bind:class="
                                              isUserConnected(msg.user_id)
                                                ? 'connected'
                                                : 'disconnected'
                                            "
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </div>

                        <div v-if="this.selectTab === 1" class="scroll-members">
                          <div class="members-content members-mobile">
                            <div class="Co-locataires">Co-locataires</div>

                            <div
                              v-for="user of currentChat.users"
                              v-bind:key="'USER-COLOC-' + user.id"
                            >

                              <router-link v-if="getColocAndPro(user.id)"
                                           :to="{ name: 'UserProfile', params: { user_id: user.id }}" target="_blank">

                                <div class="cont">
                                  <div class="user-list">
                                    <div class="user-pic">
                                      <chat-picture
                                        :users="[
                          {
                            avatar_id: user.avatar_id,
                            avatar_color: user.avatar_color,
                          },
                        ]"
                                        :h="'24px'"
                                        :w="'24px'"
                                      />

                                      <div class="status-user">
                                        <div
                                          v-bind:class="
                            isUserConnected(user.id)
                              ? 'connected'
                              : 'disconnected'
                          "
                                        ></div>
                                      </div>
                                    </div>
                                    <div class="status-user"></div>
                                  </div>

                                  <div class="ellipsis">
                                    {{ getUserNameBy(user.id, true) }}
                                  </div>
                                </div>

                              </router-link>

                            </div>

                            <div class="Participants">Participants</div>

                            <div
                              v-for="user of currentChat.users"
                              v-bind:key="'USER-PAR-' + user.id"
                            >

                              <router-link :to="{ name: 'UserProfile', params: { user_id: user.id }}" target="_blank">
                                <div class="cont" v-if="!getColocAndPro(user.id)">
                                  <div class="user-list">
                                    <div class="user-pic">
                                      <chat-picture
                                        :users="[
                          {
                            avatar_id: user.avatar_id,
                            avatar_color: user.avatar_color,
                          },
                        ]"
                                        :h="'24px'"
                                        :w="'24px'"
                                      />

                                      <div class="status-user">
                                        <div
                                          v-bind:class="
                            isUserConnected(user.id)
                              ? 'connected'
                              : 'disconnected'
                          "
                                        ></div>
                                      </div>
                                    </div>

                                    <div class="status-user"></div>
                                  </div>

                                  <div class="ellipsis">

                                    {{ getUserNameBy(user.id, true) }}

                                  </div>
                                </div>
                              </router-link>

                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>

              <!--<dashboard-newsletter></dashboard-newsletter>-->
              <simple-popup :popup="popupInfo"></simple-popup>
              <simple-popup :popup="popupError"></simple-popup>
              <ui-modal v-if="confirmBlock"
                @close="confirmBlock = false" title="Bloquer l'utilisateur">
                Voulez-vous vraiment bloquer l'utilisateur
                {{ confirmBlock.users[0].name }} ?
                <template slot="buttons">
                  <ui-button class="white-button" @click="!toggleBlockLoading && (confirmBlock = false)">
                    Non
                  </ui-button>
                  <ui-button class="white-button mfp-close" @click="!toggleBlockLoading && toggleBlockUser(confirmBlock)">
                    Oui
                  </ui-button>
                </template>
              </ui-modal>

              <ui-modal
                v-if="modalLeavGroupe"
                @close="modalLeavGroupe = false"
                title="QUITTER LE GROUPE"
              >
                <div class="group-button-text">
                  Etes-vous sûr de vouloir quitter ce groupe ?
                  <br/>
                  <br/>

                  Vous pourrez de nouveau le rejoindre depuis la page de l’annonce
                  du logement.
                </div>

                <template slot="buttons">
                  <div class="group-button group-button-text">
                    <ui-button class="white-button" @click="modalLeavGroupe = false">
                      Rester dans le groupe
                    </ui-button>
                    <ui-button @click="separateGroupe">
                      Quitter le groupe
                    </ui-button>
                  </div>
                </template>
              </ui-modal>

            </div>
          </div>
          <!-- end chat-history -->

          <div
            class="gb-form-field gb-form-field--with-action field-send-message"
          >
            <!-- Input -->
            <div class="container-form-chat-msg-texte" v-if="currentChat">
              <div v-if="isLoadingJoined">
                <center>
                  <div class="loader-wrapper-small">
                    <div class="loader big"></div>
                  </div>
                </center>
              </div>

              <div v-else>
                <form
                  v-if="!isPublic && !isUserJoind && this.selectTab === 0"
                  id="form-chat-msg-texte"
                  @submit.prevent="sendMessage"
                >
                  <div class="form-group form-sans-label form-chat-msg-texte">
                    <label for="form-textarea-chat-msg-texte"
                    >Votre message</label
                    >
                    <auto-grow-input
                      :disabled="currentChat.dislike"
                      tabindex="0"
                      id="form-textarea-chat-msg-texte"
                      class="textarea-scrollbar scrollbar-outer"
                      ref="autoGrowInput"
                      :maxlength="1000"
                      placeholder="Votre message..."
                      v-model="newMsg"
                      v-on:keydown.enter.prevent="sendMessage"
                      @sendMessage="sendMessage"
                    />
                  </div>
                </form>

                <div v-if="(isPublic  ) || isUserJoind && !isLoadingJoined" class="center-button">
                  <center class="join-margin">
                    <ui-button
                      @click="joinGroup"
                      id="join-chat"
                      type="submit"
                      :h="'36px'"
                    >
                      <div>Rejoindre la conversation</div>
                    </ui-button>
                  </center>
                </div>

                <div @click="modalLeavGroupe = true"
                     v-else-if="isMobile && !isUserJoind &&
                                !this.getColocAndPro(user.id)
                            && this.selectTab == 1
                            ">
                  <center class="join-margin">
                    <ui-button
                      type="submit"
                      :h="'36px'"
                    >
                      <div>Quitter la groupe</div>
                    </ui-button>
                  </center>

                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="chat-right">
          <div>

            <section class="members-section">
              <div class="members" @click="toggelMembers()">
                <img
                  src="/static/images/round_navigate_next_black_18dp.png"
                  alt=""
                  class="svg-icons arrow-left"
                  v-if="!toggleMembersContent"
                />
                <svgicon icon="groupe-of-person" class="group-of-person"/>
                <img
                  src="/static/images/round_navigate_next_black_18dp.png"
                  v-if="toggleMembersContent"
                  alt=""
                  class="svg-icons"
                />
              </div>

              <div class="members-content">
                <div class="Co-locataires">Co-locataires</div>

                <div
                  v-for="user of currentChat.users"
                  v-bind:key="'USER-COLOC-' + user.id"
                >

                  <router-link v-if="getColocAndPro(user.id)" :to="{ name: 'UserProfile', params: { user_id: user.id }}"
                               target="_blank">

                    <div class="cont">
                      <div class="user-list">
                        <div class="user-pic">
                          <chat-picture
                            :users="[
                          {
                            avatar_id: user.avatar_id,
                            avatar_color: user.avatar_color,
                          },
                        ]"
                            :h="'24px'"
                            :w="'24px'"
                          />

                          <div class="status-user">
                            <div
                              v-bind:class="
                            isUserConnected(user.id)
                              ? 'connected'
                              : 'disconnected'
                          "
                            ></div>
                          </div>
                        </div>
                        <div class="status-user"></div>
                      </div>

                      <div class="ellipsis">
                        {{ getUserNameBy(user.id, true) }}
                      </div>
                    </div>

                  </router-link>

                </div>

                <div class="Participants">Participants</div>

                <div
                  v-for="user of currentChat.users"
                  v-bind:key="'USER-PAR-' + user.id"
                >

                  <router-link :to="{ name: 'UserProfile', params: { user_id: user.id }}" target="_blank">
                    <div class="cont" v-if="!getColocAndPro(user.id)">
                      <div class="user-list">
                        <div class="user-pic">
                          <chat-picture
                            :users="[
                          {
                            avatar_id: user.avatar_id,
                            avatar_color: user.avatar_color,
                          },
                        ]"
                            :h="'24px'"
                            :w="'24px'"
                          />

                          <div class="status-user">
                            <div
                              v-bind:class="
                            isUserConnected(user.id)
                              ? 'connected'
                              : 'disconnected'
                          "
                            ></div>
                          </div>
                        </div>

                        <div class="status-user"></div>
                      </div>

                      <div class="ellipsis">

                        {{ getUserNameBy(user.id, true) }}

                      </div>
                    </div>
                  </router-link>

                </div>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
    <!-- end chat -->
  </div>
</template>
<script>
/* global $ */
import { eventBus, hasSubscription, registrationHelpers } from '@/main'
import AutoGrowInput, { textToHTML } from '@/ui/AutoGrowInput'
import UsersAvatars from '../../common/UsersAvatars.vue'
import * as service from '@/service'

export default {
  name: 'dashboard-messages',
  props: {
    openDiscution: Number,
    home: {
      type: Object,
      required: true,
    },
    preview: Boolean,
    isPublic: Boolean,
    loadedUser: {
      type: Object,
    },
  },
  data: () => ({
    changeStat: true,
    coolocAndPro: [],
    imgTab: ['/static/images/chat.png', '/static/images/group-person.png'],
    selectTab: 0,
    usersParticiment: [],
    modalLeavGroupe: false,

    isLoadingJoined: false,
    toggleMembersContent: false,
    isUserJoind: true,
    isChatOpen: true,
    popupError: {
      id: 'popup-error-profile',
      title: '',
      content: '',
      link: '',
      linktitle: '',
    },
    popupInfo: {
      id: 'popup-dislike-info',
      title: '',
      content: '',
      link: '',
      linktitle: '',
    },
    connected_users: [],
    newMsg: '',
    msgInformation: false,
    user: {},
    discussions: [],
    contactToFind: '',
    loadDiscussionDebounce: 0,
    loadingDiscussions: false,
    endDiscussions: false,
    loadingDiscussionsPromise: Promise.resolve(),
    idle: false,
    notifAvailable: false,
    notifEnabled: false,
    notifToggling: false,
    service_client_id: null,
    mobileBlockBtns: false,
    confirmBlock: false,
    toggleBlockLoading: false,
    chatHome: {},
  }),
  computed: {
    has_subscription() {
      return hasSubscription(this.user)
    },

    currentChat() {
      const res = this.chatHome
      if (res) {
        document.documentElement.classList.add('messenger-home--open')
      } else {
        document.documentElement.classList.remove('messenger-home--open')
      }
      return res
    },
    isMobile() {
      return this.$mq === 'mobile'
    },
    isPro() {
      return this.user && !registrationHelpers.userTypes.is(this.user, 'coloc')
    },
  },
  watch: {
    openDiscution: function (newVal, oldVal) {
      if (this.isChatOpen) {
        this.togleChat()
        this.isChatOpen != this.isChatOpen
      }
    },
    contactToFind() {
      this.discussions = []
      this.endDiscussions = false
      this.setLoadingDiscussions(true)
      clearTimeout(this.loadDiscussionDebounce)
      this.loadDiscussionDebounce = setTimeout(this.loadDiscussions, 300)
    },
    '$route.query.home_id'() {
      this.loadDiscussions()
    },
  },
  methods: {

    getCurrentMesageFilter() {
      try {
        const messages = [...new Map(this.chatHome.messages.map((item) => [item.id, item])).values()]

        if (messages) return messages

        this.scrollToLastMsg()
      } catch (error) {}
    },
    getUsersOfDiscution() {
      let urlDiscussion = ''

      if (this.isPublic) {
        urlDiscussion = '/api/discussions-for-homes-public/'
      } else {
        urlDiscussion = '/api/discussions-for-homes/'
      }
      urlDiscussion = urlDiscussion + this.home.id + '/group-' + this.home.group_id

      // get users of home
      this.$http
        .get(urlDiscussion)
        .then((res) => {
          this.chatHome.users = res.data.users
        })
    },
    checkInformationMsg(msg) {
      if (msg.includes(' a rejoint la conversation') || msg.includes(' a quitté la conversation')) {
        this.getUsersOfDiscution()
        return true
      } else {
        return false
      }
    },
    getAvatar(id) {
      try {
        const user = this.chatHome.users.find(user => user.id === id)
        return {
          avatar_id: user.avatar_id,
        }
      } catch (error) {
        return {}
      }
    },

    isUserProPrio() {
      if (this.user.first_name === 'Service Client') { return true }
      if (this.home.user_id === this.user.id) { return true } else { return false }
    },

    getColocAndPro(id) {
      // get the pro and cooloc from users in chat room
      const userId = []

      const serviceClient = this.currentChat.users.find(e => e.first_name == 'Service Client')

      if (serviceClient) {
        userId.push(serviceClient.id)
      }

      this.home.rooms.forEach(room => {
        try {
          userId.push(room.user.id)
        } catch (error) {}
      })

      userId

      return userId.includes(id)
    },
    isUserConnected(id) {
      try {
        const ServiceClient = this.currentChat.users.find(e => e.id === id && e.first_name == 'Service Client')
        if (ServiceClient !== undefined) return true
        if (id === this.user.id) return true

        const user = this.chatHome.connected.find((e) => e === id)
        if (user === undefined) return false
        else return true
      } catch (error) {
        return false
      }
    },
    toggelMembers() {
      this.toggleMembersContent = !this.toggleMembersContent
      $('.members-content').toggle(300)
    },
    textToHTML,
    togleChat() {
      $('.chat-cnt').slideToggle(300, 'swing')
      this.isChatOpen = !this.isChatOpen

      this.scrollToLastMsg()
    },
    joinGroup() {
      const ev = {
        canceled: false,
      }
      this.$emit('joinGroup', ev)
      if (ev.canceled) return

      this.isLoadingJoined = true

      // Get list id of participant
      const users = this.chatHome.users.map((e) => e.id)

      // Add current user to particment
      users.push(this.user.id)

      // payload
      const data = {
        user_ids: users,
        name: this.chatHome.group_name,
        body: this.user.first_name + ' ' + this.user.name[0].toUpperCase() + ' a rejoint la conversation',
      }

      // Call Api
      this.$http
        .put(`/api/groups/${this.chatHome.id.substr(6)}`, data)
        .then((res) => {
          let avatar_id
          let avatar_color

          // Check if avatar exist and approved
          if (this.user.avatar && this.user.avatar.approved) {
            avatar_id = this.user.avatar.avatar_id
            avatar_color = this.user.avatar.avatar_color
          }
          // Add user and message
          this.chatHome.users.push({
            avatar_id: avatar_id,
            favorite: false,
            id: this.user.id,
            name: this.user.first_name + ' ' + this.user.name[0].toUpperCase(),
            avatar_color: avatar_color,
          })

          this.isUserJoind = false
          this.newMsg = this.user.first_name + ' ' + this.user.name[0].toUpperCase() + ' a rejoint la conversation',
          this.msgInformation = true
          this.sendMessage()
        })
        .then(() => {
          this.isLoadingJoined = false
        })
    },
    separateGroupe() {
      this.isLoadingJoined = true
      this.modalLeavGroupe = false

      // Remove current user from list of participent
      let users = this.chatHome.users.filter((e) => e.id !== this.user.id)
      users = users.map((e) => e.id)

      // paylod of api
      const data = {
        user_ids: users,
        name: this.chatHome.group_name,
        body: this.user.first_name + ' ' + this.user.name[0].toUpperCase() + ' a quitté la conversation',
      }

      // call api
      this.$http
        .put(`/api/groups/${this.chatHome.id.substr(6)}`, data)
        .then((res) => {
          // remove user from liste of particiment
          this.chatHome.users = this.chatHome.users.filter(
            (e) => e.id !== this.user.id,
          )
          this.isUserJoind = true
          this.newMsg = this.user.first_name + ' ' + this.user.name[0].toUpperCase() + ' a quitté la conversation'
          this.msgInformation = true
          this.sendMessage()
        })
        .then(() => {
          this.isLoadingJoined = false
        })
    },

    getUserNameFromMessage(msg) {
      try {
        if (this.user && msg.user_id === this.user.id) {
          return 'Moi'
        } else {
          if (msg.first_name) {
            return msg.first_name.charAt(0).toUpperCase() + msg.first_name.slice(1) + ' ' + msg.name.charAt(0).toUpperCase()
          }
          const user = this.chatHome.users.find(user => user.id === msg.user_id)
          return user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1) + ' ' + user.name.charAt(0).toUpperCase()
        }
      } catch (error) {
        return ''
      }
    },
    getUserNameBy(id, listUser) {
      try {
        if (id === this.user.id) {
          // If current user return Me
          return 'Moi'
        } else {
          // Fin sender user
          const user = this.chatHome.users.find((o) => o.id == id)

          // check if first name not null
          if (listUser) {
            return user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1) + ' ' + user.name
          } else {
            return user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1) + ' ' + user.name.charAt(0).toUpperCase()
          }
        }
      } catch (error) {}
    },
    formatDate(dateFormat) {
      const date = new Date(dateFormat)
      let res = ''
      const now = new Date()
      if (
        now.getDate() !== date.getDate() ||
        now.getMonth() !== date.getMonth() ||
        now.getYear() !== date.getYear()
      ) {
        res += date.toLocaleDateString()
        res += ' '
      }
      const pad = (n) => (n > 9 ? n : '0' + n)
      return res + pad(date.getHours()) + ':' + pad(date.getMinutes())
    },
    scrollToLastMsg() {
      this.$nextTick(() => {
        const message = this.chatHome
        this.chatHome = []
        this.chatHome = message

        const el = document.getElementById('chatScroll')
        if (el != null) el.scrollTop = el.scrollHeight
      })
    },
    // Keep a promise that resolves when discussion loading is done
    setLoadingDiscussions(val) {
      if (this.loadingDiscussions === val) return
      this.loadingDiscussions = val

      if (val) {
        // Create a waiting promise
        this.loadingDiscussionsPromise = new Promise((resolve) => {
          this.$nextTick(() => {
            this.loadingDiscussionsPromise._doResolve = resolve
          })
        })
      } else if (this.loadingDiscussionsPromise._doResolve) {
        this.loadingDiscussionsPromise._doResolve()
      } else {
        this.$nextTick(
          () =>
            this.loadingDiscussionsPromise._doResolve &&
            this.loadingDiscussionsPromise._doResolve(),
        )
      }
    },
    getMessages(recipient_id) {
      this.newMsg = ''

      // if (this.$route.query.id !== recipient_id) {
      //   this.$router.push({ query: { id: recipient_id } });
      // }

      const chat = this.currentChat
      if (!chat) {
        this.getChatByID(recipient_id).then((chat) => {
          if (!chat) {
            this.$router.push({ name: 'DashboardMessages' })
          } else {
            this.getMessages(recipient_id)
          }
        })
        return
      }

      if (window.localStorage && localStorage.getItem('prebuiltMessage')) {
        this.newMsg = localStorage.getItem('prebuiltMessage')
        localStorage.removeItem('prebuiltMessage')
      }

      // Update chat infos
      chat.messages = []
      this.$set(chat, 'loading', true)

      let urlMessages = ''

      if (this.isPublic) {
        urlMessages = '/api/messages-public/'
      } else {
        urlMessages = '/api/messages/'
      }
      urlMessages = urlMessages + 'home-' + this.home.id + '/' + recipient_id

      // let url = `/api/messages${this.isPro ? '-for-homes/' + (this.$route.query.home_id || 'default') : ''}/${recipient_id}`
      this.$http.get(urlMessages).then(
        (res) => {
          chat.messages = res.data.messages
          chat.loading = false

          // Last chat date
          if (chat.messages.length > 0) {
            // Convert to real dates
            for (const msg of chat.messages) {
              chat.last_message_date = msg.created_at = new Date(
                msg.created_at,
              )
            }
          }

          // Count how much message are now 'readed'
          eventBus.$emit('chat:read', res.data.unread)
          chat.unread = 0

          this.scrollToLastMsg()
        },
        (error) => {
          this.error = error
          chat.loading = false
          registrationHelpers.show(
            this,
            {
              title: 'Impossible de contacter cet utilisateur',
              text: 'Cet utilisateur vous a bloqué. Vous ne pouvez donc pas lui envoyer de message.',
            },
            'popup-dislike-info',
          )
          console.error(error)
        },
      )
    },
    async loadDiscussions() {
      const params = {
        search: this.contactToFind,
        last_prio: 0,
        last_date: 0,
        loaded_ids: [],
      }

      // Check if groupe of home exist
      if (this.home.group_id.replace(/[0-]/g, '') === '' || this.home.group_id === null) {
        // update the home for creating the groupe
        await this.$http.put(`/api/homes/${this.home.id}?is_creation_group=true`, this.home).then((response) => {
          this.home.group_id = response.data.group_id
        })
      }

      let urlDiscussion = ''

      if (this.isPublic) {
        urlDiscussion = '/api/discussions-for-homes-public/'
      } else {
        urlDiscussion = '/api/discussions-for-homes/'
      }
      urlDiscussion = urlDiscussion + this.home.id + '/group-' + this.home.group_id

      // get discution of home
      this.$http
        .get(urlDiscussion)
        .then((res) => {
          if (!this.isPublic) {
            this.isUserJoind =
              res.data.users.find((e) => e.id == this.user.id) == undefined
          } else {
            this.isUserJoind = false
          }

          this.chatHome = res.data

          // get message of groupe
          this.getMessages('group-' + this.home.group_id)
        })

      // Get last prio, last message date and ids of chat already loaded with last prio + last message date
      const l = this.discussions.length
      if (l > 0) {
        const dateToInt = (d) => (d ? Math.ceil(d.getTime() / 1000) : -1)

        const last = this.discussions[l - 1]
        params.last_prio = last.prio
        params.last_date = dateToInt(last.last_message_date)

        for (const chat of this.discussions) {
          if (
            (params.last_prio === 0 || chat.prio >= params.last_prio) &&
            (params.last_date === 0 ||
              dateToInt(chat.last_message_date) <= params.last_date)
          ) {
            params.loaded_ids.push(chat.id)
          }
        }
      }
      params.loaded_ids = params.loaded_ids.join(',')

      const url = `/api/discussions${
        this.isPro
          ? '-for-homes/' + (this.$route.query.home_id || 'default')
          : ''
      }`

      this.setLoadingDiscussions(true)
      this.$http.get(url, { params }).then(
        (res) => {
          const { connected, discussions, end } = res.data
          this.connected_users = this.connected_users.concat(connected)
          this.endDiscussions = end
          for (const discussion of discussions) {
            if (discussion.prio === 0) {
              this.service_client_id = discussion.id
            }
            if (discussion.last_message_date) {
              discussion.last_message_date = new Date(
                discussion.last_message_date,
              )
            }
            discussion.dislike =
              discussion.users.length === 1 && discussion.users[0].dislike

            const existing = this.discussions.find((d) => discussion.id === d.id)
            if (existing) {
              this.updateDiscussion(existing, discussion)
            } else {
              discussion.messages = []
              this.discussions.push(discussion)
            }
          }

          this.setLoadingDiscussions(false)
        },
        (err) => {
          this.error = err
          this.setLoadingDiscussions(false)
          console.error(err)
        },
      )
    },
    toggleBlockUser(chat) {
      this.toggleBlockLoading = true
      const user = chat.users[0]
      this.$http
        .get(window.location.origin + `/api/users/${user.id}/dislike`)
        .then(
          (res) => {
            this.toggleBlockLoading = false
            this.confirmBlock = false

            // Reload discussions
            this.discussions = []
            this.endDiscussions = false
            this.connected_users = []
            this.setLoadingDiscussions(true)
            this.loadDiscussions()

            if (res.data) {
              // Blocked
              this.$router.push({ name: 'DashboardMessages' })
            } else {
              // Unblocked, load messages
              this.loadingDiscussionsPromise.then(() => {
                this.getMessages(chat.id)
              })
            }
          },
          (err) => {
            //TODO: error
            console.error(err)
            this.toggleBlockLoading = false
          },
        )
    },
    reportToSupport(chat) {
      const user = chat.users[0]
      this.getMessages(this.service_client_id)
      this.newMsg = `Bonjour, je souhaite signaler l'utilisateur <user ${user.id}>${user.name}</user> pour la raison suivante : `
      this.$nextTick(() => {
        this.$refs.autoGrowInput.focus()
      })
    },
    onScroll(ev) {
      if (this.loadingDiscussions || this.endDiscussions) return

      // Calculate space left at the bottom
      const div = ev.target
      const bottom = div.scrollHeight - div.scrollTop - div.offsetHeight

      if (bottom < 200) {
        this.setLoadingDiscussions(true)
        clearTimeout(this.loadDiscussionDebounce)
        this.loadDiscussions()
      }
    },
    // Update chat with data, and reorder in list
    updateDiscussion(chat, data) {
      //TODO: don't append if not in search
      for (const key in data) {
        this.$set(chat, key, data[key])
      }

      // Fix prio
      if (chat.prio === 3 && chat.last_message_date) {
        chat.prio = 1
      }

      // Remove from list
      const current = this.discussions.findIndex((d) => d.id === chat.id)
      if (current >= 0) {
        this.discussions.splice(current, 1)
      }

      // Find new index and add it there
      for (let i = 0, l = this.discussions.length; i < l; i++) {
        const c = this.discussions[i]
        if (c.prio > chat.prio) {
          this.discussions.splice(i, 0, chat)
          return
        } else if (c.prio === chat.prio) {
          const cd = c.last_message_date ? c.last_message_date : 0
          const chatd = chat.last_message_date ? chat.last_message_date : 0
          if (cd < chatd) {
            this.discussions.splice(i, 0, chat)
            return
          }
        }
      }

      // Last
      this.currentChat = chat
      this.discussions.push(chat)
    },
    sendMessage() {
      if (this.newMsg.trim() !== '') {
        const chat = this.currentChat
        if (!chat) return

        const data = {
          body: this.newMsg,
          is_information: this.msgInformation,
        }

        const message = {
          id: Date.now(),
          created_at: new Date(),
          body: this.newMsg,
          user_id: this.user.id,
          readed: true,
          saving: true,
          is_information: this.msgInformation,
        }

        // Sender
        const url = '/api/messages-for-homes/' + this.home.id + '/'

        // Receiver
        if (chat.id.substring(0, 5) === 'home-') {
          // Home + group
          const parts = chat.id.split('/')
          if (parts.length === 2) {
            data.recipient_home_id = message.recipient_home_id =
              parts[0].substring(5)
            data.group_id = message.group_id = parts[1].substring(6)
          } else {
            data.recipient_home_id = message.recipient_home_id =
              chat.id.substring(5)
          }
        } else if (chat.id.substring(0, 6) === 'group-') {
          data.group_id = message.group_id = chat.id.substring(6)
        } else {
          data.recipient_id = message.recipient_id = chat.id
        }

        chat.messages.push(message)
        this.scrollToLastMsg()
        this.newMsg = ''
        this.msgInformation = false
        this.isMessageSaving =

          this.$http.post(url, data).then(
            (res) => {
              message.id = res.data.id
              message.created_at = new Date(res.data.created_at)
              message.saving = false

              // update stats
              this.changeStat = !this.changeStat

              const discussion = this.discussions.find((d) => d.id === chat.id)
              if (
                discussion &&
                (!discussion.last_message_date ||
                  discussion.last_message_date < message.created_at)
              ) {
                this.updateDiscussion(discussion, {
                  last_message_date: message.created_at,
                })
              }
              this.scrollToLastMsg()
            },
            (error) => {
              message.saving = error
              console.error(error)
            },
          )
      }
    },
    // Bottom of page
    scrollbottom(event) {
      $('.chatroom ').each(() => $(this).scrollTop($(this)[0].scrollHeight))
    },
    // Return the chat by ID (load if needed)
    getChatByID(id, no_update) {
      // Wait that discussions are loaded
      return this.loadingDiscussionsPromise.then(() => {
        // Chat is loaded
        const chat = this.discussions.find((d) => d.id === id)
        if (chat) return chat

        // Load chat needed
        const url = `/api/discussions${
          this.isPro
            ? '-for-homes/' + (this.$route.query.home_id || 'default')
            : ''
        }/${id}`
        return this.$http.get(url).then(
          (res) => {
            const discussion = res.data
            discussion.dislike =
              discussion.users.length === 1 && discussion.users[0].dislike
            if (discussion.last_message_date) {
              discussion.last_message_date = new Date(
                discussion.last_message_date,
              )
            }

            if (!no_update) {
              this.updateDiscussion(discussion, {
                last_message_date: new Date(),
                messages: [],
              })
            }

            if (discussion.connected === true) {
              this.connected_users.push(discussion.id)
            } else if (Array.isArray(discussion.connected)) {
              this.connected_users = this.connected_users.concat(
                discussion.connected,
              )
            }
            return discussion
          },
          (err) => {
            console.error(err)
            return null
          },
        )
      })
    },
    isOnline(chat) {
      for (const user of chat.users) {
        if (this.connected_users.includes(user.id)) {
          return true
        }
      }
      return false
    },

    getChatHome() {
      return this.chatHome
    },
    // New message received by websocket
    onMessage(data) {
      let chat_id = this.home.id
      chat_id = '/group-' + data.group_id

      // Find chat
      const chat = this.chatHome

      // Set as readed
      const sendReaded = () =>
        this.$http
          .put(
            `/api/discussions${
              this.isPro
                ? '-for-homes/' + (this.this || 'default')
                : ''
            }/${chat_id}/read`,
          )
          .catch((err) => console.error(err))
      sendReaded()
      if (!this.idle) {
        sendReaded()
      } else {
        eventBus.$once('chat:idle', (state) => {
          if (state === false) sendReaded()
        })
      }
      eventBus.$emit('chat:read', 1)

      // Append message
      const message = {
        id: data.id,
        created_at: new Date(data.created_at),
        body: data.body,
        user_id: data.user_id,
        recipient_id: this.user.id,
        group_id: data.group_id,
        readed: true,
      }

      // Put it in the right position
      let inserted = false
      for (let i = chat.messages.length - 1; i >= 0; i--) {
        const msg = chat.messages[i]
        if (msg.created_at < message.created_at) {
          inserted = true
          chat.messages.splice(i + 1, 0, message)
          break
        }
      }

      if (!inserted) {
        chat.messages.push(message)
      }
      const chatH = this.chatHome
      this.chatHome = []
      this.chatHome = chatH

      this.scrollToLastMsg()
    },
    // User id is now online
    onOnline(user_id) {
      if (this.currentChat.connected) { this.currentChat.connected.push(user_id) }
    },
    // User id is now offline
    onOffline(user_id) {
      if (!this.currentChat || !this.currentChat.connected) return
      this.currentChat.connected = this.currentChat.connected.filter(
        (id) => id !== user_id,
      )
    },
    // Idle status changes
    onSetIdle(state) {
      this.idle = state
    },

    // Disable/enable notification push
    toggleNotif() {
      if (this.notifToggling) return
      this.notifToggling = true

      const p = this.notifEnabled
        ? service.unsubscribeUser()
        : service.subscribeUser()
      p.then((success) => {
        if (success) this.notifEnabled = !this.notifEnabled
        this.notifToggling = false
      })
    },
    getUserFromGroup(msg) {
      if (!this.currentChat && !this.currentChat.users) return
      const res = this.currentChat.users.find((u) => u.id === msg.user_id)
      if (res) return res.name
      return ''
    },
  },
  mounted() {
    // close the chat box
    document.documentElement.classList.add('messenger-home')

    registrationHelpers.fetchDataUser(this, vi => {
      this.loadDiscussions()
      if (this.$route.query.id) {
        this.getMessages(this.$route.query.id)
      }
    }, this.isPublic || this.preview)
    $('.chat-cnt').hide()

    eventBus.$on('chat:message', this.onMessage)
    eventBus.$on('chat:online', this.onOnline)
    eventBus.$on('chat:offline', this.onOffline)
    eventBus.$on('chat:idle', this.onSetIdle)

    Promise.all([service.isPushAvailable(), service.isPushEnabled()]).then(
      (res) => {
        this.notifAvailable = res[0]
        this.notifEnabled = res[1]

        /*TODO: if user says no, it's blocked forever

      if (this.notifAvailable && !this.notifEnabled && !localStorage.getItem('ask_msg_notif')) {
        localStorage.setItem('ask_msg_notif', true)
        this.toggleNotif()
      }*/
      },
    )
  },
  beforeDestroy() {
    document.documentElement.classList.remove('messenger-home')
    document.documentElement.classList.remove('messenger-home--open')

    eventBus.$off('chat:message', this.onMessage)
    eventBus.$off('chat:online', this.onOnline)
    eventBus.$off('chat:offline', this.onOffline)
    eventBus.$off('chat:idle', this.onSetIdle)
  },
  components: {
    AutoGrowInput,
    NotifIcon: require('@/ui/icons/NotificationIcon').default,
    ChatPicture: require('@/ui/ChatPicture').default,
    UiButton: require('@/ui/Button').default,
    UiModal: require('@/ui/Modal').default,
    UsersAvatars,
  },
}
</script>

<style lang="scss">
@import "../../../../static/scss/variables";

.messenger-home {
  /* ---------- LIVE-CHAT ---------- */

  .overflow-text {
    overflow-wrap: break-word;
  }

  .group-button-text {
    font-size: 14px;
  }

  .gray-button-pop {
    margin-top: 18px;
    min-width: 200px;
    position: relative;
    background: transparent !important;
    margin: 0 auto;
    border-radius: 0;
    font-size: 1em !important;
    color: gray !important;
    border: 1px solid gray !important;
    font-weight: 400;
    padding: 9px 0 !important;
    height: auto;
  }

  .gray-button-pop:hover {
    color: white !important;
    border: 1px solid gray !important;
    background: gray !important;;
  }

  .scroll-members {
    overflow: auto;
  }

  .members-mobile {
    padding: 10px 20px 10px 20px;
  }

  .chat-participent {
    display: flex;
    flex-direction: row;
  }

  .participant {
    width: 20%;
  }

  .msg-block-participant {
    width: 80%;
  }

  .block-central {
    width: 100%;
  }

  .msg-cnt {
    width: 100%;
  }

  .svg-icons {
    filter: invert(16%) sepia(91%) saturate(4084%) hue-rotate(350deg) brightness(83%) contrast(105%);
  }

  .float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 65px;
    right: 40px;
    background-color: #d90e15;
    color: #fff;
    border-radius: 50px;
    text-align: center;
    box-shadow: 2px 2px 3px #999;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .group-button {
    display: flex;
  }

  .join-margin {
    margin: 10px;
  }

  .divider-btn {
    margin: 5px;
  }

  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    height: 25px;
    gap: 6px;
    margin: 4px 43.1px 12px 24px;
    padding: 6px;
    border: solid 0.6px #c4c4c4;
    background-color: #e7e8e9;
    color: #766e6a;
    left: 113%;

    visibility: hidden;
    width: 120px;
    text-align: center;
    position: absolute;
    z-index: 1;
    bottom: -157%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  .status-user {
    border-radius: 50px;
    width: 8px;
    height: 8px;
    bottom: -2px;
    right: -2px;
    position: absolute;
    border: 1px solid white;

    .connected {
      border-radius: 50px;
      width: 6px;
      height: 6px;
      background-color: #75cd31;
    }

    .disconnected {
      border-radius: 50px;
      width: 6px;
      height: 6px;
      background-color: #d90e15;
    }
  }

  .user-pic {
    border-radius: 50px;
    height: 24px;
    width: 24px;
    position: relative;
  }

  .connected-status {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    height: 48px;
    right: 0;

    .status {
      position: absolute;
      bottom: 0;
      right: 28px;
      width: 12px;
      height: 12px;
      flex-grow: 0;
      border-radius: 30px;
      border: 1px solid white;
    }

    .connected {
      background-color: #75cd31;
    }

    .disconnected {
      background-color: #d90e15;
    }

    .sender-user {
      right: 7px;
    }
  }

  .arrow-top {
    filter: invert(15%) sepia(56%) saturate(6744%) hue-rotate(350deg) brightness(87%) contrast(105%);

    transform: rotate(270deg);
    cursor: pointer;
  }

  .group-of-person {
    filter: invert(16%) sepia(91%) saturate(4084%) hue-rotate(350deg) brightness(83%) contrast(105%);
  }

  .members {
    // Remove selection

    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */

    filter: invert(16%) sepia(91%) saturate(4084%) hue-rotate(350deg) brightness(83%) contrast(105%);
    cursor: pointer;
  }

  h4,
  h5 {
    line-height: 1.5em;
    margin: 0;
  }

  .ellipsis {
    width: 80%;
    padding: 10px;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 5px;
    margin-bottom: 10px;
    color: #766e6a;
  }

  .cont {
    width: 100%;
    display: flex;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .img-user {
    margin-left: 0px;
    width: 20%;
  }

  .test {
    margin: 0px;
  }

  .clearfix {
    *zoom: 1;
  }

  /* For IE 6/7 */
  .clearfix:before,
  .clearfix:after {
    content: "";
    display: table;
  }

  .clearfix:after {
    clear: both;
  }

  /* ---------- LIVE-CHAT ---------- */

  #live-chat {
    border: solid 1px #c4c4c4;
    bottom: 0;
    font-size: 12px;
    right: 24px;
    position: fixed;
    width: 500px;
  }

  #live-chat header {
    display: flex;
    justify-content: space-between;
  }

  #live-chat h4:before {
    background: #1a8a34;
    border-radius: 50%;
    content: "";
    display: inline-block;
    height: 8px;
    margin: 0 8px 0 0;
    width: 8px;
  }

  #live-chat h4 {
    font-size: 12px;
  }

  #live-chat h5 {
    font-size: 10px;
  }

  .chat-message-counter {
    background: #e62727;
    border: 1px solid #fff;
    border-radius: 50%;
    display: none;
    font-size: 12px;
    font-weight: bold;
    height: 28px;
    left: 0;
    line-height: 28px;
    margin: -15px 0 0 -15px;
    position: absolute;
    text-align: center;
    top: 0;
    width: 28px;
  }

  .chat-close {
    display: flex;
    width: 100%;
    justify-content: inherit;
    background: #1b2126;
    border-radius: 50%;
    color: #fff;
    display: block;
    float: right;
    font-size: 10px;
    height: 16px;
    line-height: 16px;
    margin: 2px 0 0 0;
    text-align: center;
    width: 16px;
  }

  .chat {
    background: white;
    width: 80%;
  }

  .chat-history {
    height: 452px;
    padding: 8px;
    overflow-y: scroll;
  }

  .chat-message {
    margin: 16px 0;
  }

  .chat-message img {
    border-radius: 50%;
    float: left;
  }

  .chat-message-content {
    margin-left: 56px;
  }

  .chat-time {
    float: right;
    font-size: 10px;
  }

  .chat-feedback {
    font-style: italic;
    margin: 0 0 0 80px;
  }

  .gb-form-field {
    position: relative;

    &--with-action {
      .gb-icon {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }

      .gb-form-control {
        padding-right: 32px;
      }
    }
  }

  .gb-icon {
    display: inline-block;
    vertical-align: middle;
    background: #000;
    width: 10px;
    height: 10px;
  }

  .gb-form-control {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 38px;
    padding: 6px 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #fff;
    color: #6d6e70;
    font-family: "Museo Sans", Arial, Helvetica, sans-serif;
    font-size: 1rem;
    line-height: 1.5;
  }

  .gb-form-control:focus {
    border-color: #75b9f0;
    outline: none;
    box-shadow: 0 0 8px #97cbf4;
  }

  .information-msg {
    text-align: center;
    height: 14px;
    flex-grow: 0;
    margin: 10px 10px 10px 10px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    color: #c4c4c4;
  }

  .message-chat {
    padding: 0 16px 0 0;
  }

  .msg-container {
    display: flex;
  }

  .chat-left {
    width: 100%;
  }

  .chat-cnt {
    background: white;
    width: 100%;
    display: flex;
  }

  .chat-right {
    width: 30%;
    background: white;
    overflow-x: hidden;
    overflow-y: auto !important;
    scroll-behavior: auto;
    height: 452px;
  }

  .members-section {
    margin: 10px;
  }

  .Participants {
    padding: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    flex-grow: 0;
    font-family: Lato;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8931cd;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .Co-locataires {
    padding: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    margin-top: 10px;
    margin-bottom: 10px;
    font-family: Lato;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #d90e15;
  }

  .user-parti {
    display: flex;
    align-items: center;
    margin-left: 5px;
    width: 77px;
    height: 18px;
    flex-grow: 0;
    margin: 1px 0 1px 5px;
    font-family: Lato;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #766e6a;
  }

  .user-name {
    margin-left: 5px;
  }

  .row-head-comming {
    width: 80%;
    padding-top: 14px;
    font-size: 0.8em;
    line-height: 1.2em;
    color: #766e6a;
    font-weight: 300;
    text-align: center;
    vertical-align: middle;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;

    .user-heure-comming {
      display: flex;

      float: right;
    }
  }

  .user-name {
    margin-left: 5px;
    margin-right: 5px;

    color: #d90e15;
  }

  .row-head-sending {
    width: 80%;
    float: right;
    padding-top: 14px;
    font-size: 0.8em;
    line-height: 1.2em;
    color: #766e6a;
    font-weight: 300;
    text-align: center;
    vertical-align: middle;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;

    .user-heure-sending {
      float: left;
      display: flex;
    }
  }

  .chatroom-home {
    background: #ffffff;
    z-index: 999999;
    position: fixed;
    bottom: 0;
    right: 100px;
    width: 40%;
    border: solid 1px #c4c4c4;
  }

  header {
    height: auto;
    flex-grow: 0;
    border-radius: 5px 5px 0 0;

    .chat-bar-open {
      align-items: center;
      align-content: center;
      height: 100%;
      display: flex;
      justify-content: space-between;
      width: 100%;
      background: #e7e8e9;
      color: #d90e15;
      padding: 16px 24px;
      border-radius: 5px 5px 0 0;

      .close-icon {
        fill: green;
        color: black;
      }
    }

    .chat-icon {
      filter: invert(15%) sepia(56%) saturate(6744%) hue-rotate(350deg) brightness(87%) contrast(105%);

    }

    .chat-bar-close {
      border-radius: 5px 5px 0 0;
      width: 100%;
      justify-content: space-between;
      display: flex;
      align-items: center;
      align-content: center;
      width: 100%;
      background: white;
      color: #d90e15;;
      border: 1px solid #d90e15;;
      padding: 16px 24px;
    }
  }

  .chat-coloc {
    width: 154px;
    height: 19px;
    flex-grow: 0;
    margin: 3px 0 2.7px 10px;
    font-family: Lato;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #d90e15;
  }

  .scroller-bar {
    overflow-x: hidden;
    overflow-y: auto !important;
    scroll-behavior: auto;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      margin-top: 10px;
      margin-bottom: 10px;
      width: 8px;
      height: 90%;
      border-radius: 0;
      background-color: rgba($gray3, 0.6);

      &-button {
        display: none;
      }

      &-thumb {
        background-color: $gray3;
        border-radius: 0;
      }

      &-track {
        background-color: transparent;
      }
    }
  }

  .scroller {
    overflow-x: hidden;
    overflow-y: auto !important;
    scroll-behavior: auto;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 8px;
      height: 100%;
      border-radius: 10px;
      background-color: rgba($gray3, 0.6);

      &-button {
        display: none;
      }

      &-thumb {
        background-color: $gray3;
        border-radius: 8px;
      }

      &-track {
        background-color: transparent;
      }
    }
  }

  .mobile-back,
  .mobile-block,
  .mobile-block__btns {
    display: none;
  }

  .chatroom .container-msg .date-chat {
    margin-top: 47px;
  }

  .date-chat {
    position: relative;
  }

  .desktop-block__btns {
    position: absolute;
    right: 0;
    top: -8px;
  }

  // Full height loader
  .loader-wrapper {
    height: 500px;
    background: white;
    min-height: 0;
  }

  .loader-wrapper-small {
    background: white;
    min-height: 0;
    height: 50px;
    margin: 0;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .text-msg {
    font-size: 14px;
  }

  .col.block-texte {
    overflow-wrap: break-word;
  }

  .block-texte {
    width: 100%;
  }

  .notif-icon {
    float: right;
    padding-right: 15px;
  }

  #form-textarea-chat-msg-texte {
    outline: none;
  }

  .sssscontainer-msg--disliked {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden !important;

    > div {
      text-align: center;
    }
  }

  .center-button {
    padding-left: 100px;
  }

  @media #{$phone} {
    // 100% viewport size

    .center-button {
      padding-left: 0;
    }

    .row-head-comming {
      width: 100%;
    }

    .selected-tab {
      padding-bottom: 4px;
      border-bottom: 1px solid #d90e15;
    }
    #chatScroll {
      padding: 0;
    }

    .mobil-header {
      height: 50px;
      background: white;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 15px;
      align-items: center;
    }
    #live-chat {
      border: 0;
      right: 0px;
      width: 100%;
      height: calc(100% - 60px);
    }
    .chat-right {
      display: none;
    }
    .chat-cnt {
      height: 100%;
    }

    .field-send-message {
      position: fixed;
      bottom: 0;
      width: 100%;
      padding: 10px;
    }
    .chat {
      width: 100%;
    }

    body,
    #app,
    #app > .dashboard,
    #app > .dashboard > .container,
    #main,
    #main > .sscontainer,
    #main > .sscontainer > .dashboard-container,
    #main > .sscontainer > .dashboard-container .container-liste-user,
    #main
    > .sscontainer
    > .dashboard-container
    .container-liste-user
    > .scrollbar-cooloc,
    #main
    > .sscontainer
    > .dashboard-container
    .container-liste-user
    > .scrollbar-cooloc
    > .sscontainer-liste-user {
      height: 100%;
    }

    #main > .sscontainer > .dashboard-container {
      // Fix height
      .chatroom-fsqdf {
        position: fixed;
        width: 10%;
        background: rgb(19, 19, 19);
        border: 1px solid;
        padding: 20px;
        bottom: 0px;
        right: 10px;
        height: calc(100% - 585px); // minus bottom bar
        display: flex;
        flex-direction: column;

        // Take left space
        .container-chatroom {
          flex: 1;
          overflow: hidden;
          margin-bottom: 0;
        }
      }

      // Fix another height
      .sscontainer-liste-user {
        display: flex;
        flex-direction: column;
      }

      .msg-home {
        width: 100%;
      }

      // Message list
      .container-msg {
        padding: 100px;
        width: 100%;
        height: calc(100% - 40px);
        position: absolute;
        top: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        background-color: white;

        // Take left space
        .sscontainer-msg {
          flex: 1;
          overflow: hidden;
          padding-bottom: 10px;
        }

        // Chat header
        .date-chat {
          padding: 15px 0;
          margin-top: -15px;

          // Mobile back button
          .mobile-back,
          .mobile-block {
            display: block;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            cursor: pointer;
          }

          .mobile-block__btns {
            position: absolute;
            top: 0;
            right: 0;
            background: #fff;
            width: calc(100% - 50px);
            height: 98%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
          }

          .mobile-block {
            right: 0;
            left: initial;
          }

          .mobile-text {
            width: calc(100% - 70px);
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
            margin: 0 auto;
          }
        }

        // Better message box
        #form-chat-msg-texte {
          display: flex;
          flex-direction: row;

          .form-chat-msg-texte {
            flex: 1;
            margin: 0;
            max-width: calc(100% - 42px);
          }

          #form-textarea-chat-msg-texte {
            border: solid 1px $gray3;
            height: 100%;
            outline: none;
            width: 100%;
          }

          .auto-grow-input {
            padding: 0 !important;
            line-height: 1.3em;
          }

          #envoyer-chat {
            margin-left: 5px;
            margin-top: 0px !important;
            float: none;
            font-size: 0;
            width: 37px !important;
            height: 100% !important;

            span {
              background-position-x: center;
            }
          }

          #join-chat {
            margin: 20px;
            float: center;
            margin-left: 5px;
            margin-top: 10px !important;
            margin-bottom: 10px;
            font-size: 0;
            width: 37px !important;
            height: 100% !important;

            span {
              background-position-x: center;
            }
          }

          .auto-grow-input {
            padding: 0 !important;
            line-height: 1.3em;
          }
        }

        // Less space between messages
        .un-message {
          margin-bottom: 10px;
        }
      }
    }

    // Fix some huge margins
    #main {
      h2 {
        margin-top: 15px;
        margin-bottom: 10px !important;
      }
    }

    // Remove footer
    .footer-container {
      display: none;
    }

    #envoyer-chat {
      float: right;
    }

    .block-icon,
    .report-icon {
      cursor: pointer;
    }

    .notif-icon {
      float: right;
      padding-right: 0;
    }

    .desktop-block__btns {
      display: none;
    }
  }
}
</style>
